import { NavigateFunction } from "react-router-dom";
import { queryClient } from "./QueryClient";

const normalizeInternalLink = (link: string) => {
  try {
    const url = new URL(link, window.location.origin);
    if (url.origin !== window.location.origin) {
      window.location.assign(url.href);
      return undefined;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return link;
  }
};

const refetchActivePageQueries = () => {
  void queryClient.invalidateQueries({ refetchType: "active" });
};

export const navigateNotificationLink = (navigate: NavigateFunction, link?: string) => {
  if (!link) return;

  const target = normalizeInternalLink(link);
  if (!target) return;

  refetchActivePageQueries();
  navigate(target);
};
